module.exports = __webpack_public_path__ + "static/media/logo.067f62cc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.svg
// module id = 381
// module chunks = 0